import { comonDataApi } from '@/api/config-setup'
import stationDataConfigApi from '@/api/config/stationDataConfig'
import InputFile from '@/components/form-control/InputFile'
import { CopyOneIcon, DatabaseAlerIcon } from '@/components/icons'
import { XLSX_ACEPT, XLSX_FORMAT } from '@/constant/common'
import { CONFIG_SETUP_ROUTES, OPERATIONS_ROUTES } from '@/constant/route'
import useCheckOverlay from '@/features/admin/hooks/locationInterface/useCheckOverlay'
import { useAuthContext } from '@/features/auth/context'
import SetUpHeaderModal from '@/features/design-system/components/common/SetUpHeaderModal'
import SetUpLayout from '@/features/design-system/components/common/SetUpLayout'
import MapViewRightMenu from '@/features/operations/components/pages/MapView/MapViewRightMenu'
import { NotifyService } from '@/helpers'
import {
  DATA_PAGINATION,
  Emitter,
  EtZone,
  Plant,
  SearchStation,
  SetupStation,
} from '@/types'
import { AreaType } from '@/types/areaZone'
import { FertigationSetup } from '@/types/fertigation'
import { Historical } from '@/types/historical'
import { SensorDetailImport } from '@/types/sensor'
import { Soil } from '@/types/soil'
import { fileContentToBlob } from '@/ultils'
import useSearchInterface from '@features/admin/hooks/interface/useSearchInterface'
import useValidateCurrentInterface from '@features/design-system/hooks/setup/useValidateCurrentInterface'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  Button,
  Dialog,
  LinearProgress,
  LinearProgressProps,
  Stack,
  Typography,
} from '@mui/material'
import { saveAs } from 'file-saver'
import { memo, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { PinStationsOnMap } from '../../SetUpThird/components'
import CommonDataTable from '../CommonDataTable'
import classes from './styles.module.scss'

import axios from 'axios'

interface Props {}

enum STEP {
  CHOOSE_FILE = 0,
  UPLOADING,
  UPLOAD_ERROR,
  REVIEW,
  PIN_STATION,
}

const STEP_LOADING = {
  Output: 'Output',
  Input: 'Input',
  Hydraulic: 'Hydraulic',
  Fertigation: 'Fertigation',
  EtZone: 'EtZone',
  Plant: 'Plant & ET Reference',
  Emitter: 'Emitter',
  AreaZone: 'AreaZone',
  Soils: 'Soils',
  Station: 'Station',
  Sensor: 'Sensor',
  End: 'End',
}

type StepLoadingType = (typeof STEP_LOADING)[keyof typeof STEP_LOADING]

function LinearProgressWithLabel(
  props: LinearProgressProps & { value: number },
) {
  return (
    <Box sx={{ display: 'flex', ml: '20px', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress color="primary" variant="indeterminate" />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.main">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  )
}

export const SetUpSecond = memo((props: Props) => {
  const { interfaceId } = useAuthContext()
  const [progress, setProgress] = useState(0)
  const { id } = useParams()

  const navigate = useNavigate()
  const [step, setStep] = useState(STEP.CHOOSE_FILE)
  const [stepName, setStepName] = useState(STEP_LOADING.Output)

  const [hydraulic, setHydraulic] = useState<any>()
  const [fertigation, setFertigation] =
    useState<DATA_PAGINATION<FertigationSetup>>()

  const [etData, setEtData] = useState<DATA_PAGINATION<Historical>>()
  const [plantData, setPlantData] = useState<DATA_PAGINATION<Plant>>()
  const [emitter, setEmitter] = useState<DATA_PAGINATION<Emitter>>()
  const [areaZone, setAreaZone] = useState<DATA_PAGINATION<AreaType>>()
  const [etZone, setEtZone] = useState<DATA_PAGINATION<EtZone>>()
  const [soils, setSoils] = useState<DATA_PAGINATION<Soil>>()
  const [sensor, setSensor] = useState<DATA_PAGINATION<SensorDetailImport>>()
  const [loadingReset, isLoadingReset] = useState(false)

  const [isDeleted, setIsDeleted] = useState(false)
  const [page, setPage] = useState<number>(1)
  const [dataResultStation, setResultStation] = useState<any>()
  const [station, setStation] = useState<DATA_PAGINATION<SetupStation>>()
  const [param] = useState<SearchStation>({
    PageSize: 0,
    interfaceId: Number(interfaceId),
  })

  const { data: allInterfaces } = useSearchInterface({ PageSize: 0 })

  const { isValidInterface, selectedInterface, isLoading } =
    useValidateCurrentInterface({
      currentInterfaceId: id,
      allInterfaces,
      redirectTo: OPERATIONS_ROUTES.index.to,
      autoRedirect: false,
    })

  const [isSetup, setIsSetup] = useState(false)

  const [isDownloading, setIsDownloading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const _data = await stationDataConfigApi.getListWithDetail(
        Number(interfaceId),
        param,
      )
      const _dataStations = _data?.data || []
      setStation(_dataStations)
    }

    if (step === STEP.REVIEW) {
      fetchData()
    }
    //eslint-disable-ne
  }, [param, step])

  useEffect(() => {
    if (dataResultStation && dataResultStation.isPaging === true) {
      setPage(page + 1)
      setStepName(STEP_LOADING.Station)
    }
    if (dataResultStation && dataResultStation.isPaging === false) {
      setProgress(100)
      setStep(STEP.REVIEW)
    }
    return
  }, [dataResultStation])

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 95) {
          return prevProgress
        }

        return prevProgress >= 100 ? 0 : prevProgress + 5
      })
    }, 2000)

    const timerProgress = setInterval(() => {
      if (progress === 100 && stepName !== 'End') {
        setProgress(0)
      }
    }, 500)

    return () => {
      clearInterval(timer)
      clearInterval(timerProgress)
    }
  }, [progress, stepName])

  const onBack = () => {
    navigate(CONFIG_SETUP_ROUTES.setupFirst.to(id || ''))
  }

  const onErrors = () => {}

  const onDownload = async () => {
    setIsDownloading(true)
    try {
      const res = await comonDataApi.getCommonTemplate(Number(interfaceId))
      saveAs(res.data, 'CommonData_Template.xlsx')
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        toast.error('Controller does not exist')
      } else {
        toast.error('Failed to download the template. Please try again later.')
      }
    } finally {
      setIsDownloading(false)
    }
  }

  const onClose = () => {
    navigate(OPERATIONS_ROUTES.index.to)
  }

  const onTryAgain = () => {
    setStep(STEP.CHOOSE_FILE)
  }

  /**
   * @description:
   * check carefully before delete data
   */
  const handleDelete = async () => {
    isLoadingReset(true)
    try {
      // Step 1: Send the initial request with type = 1 and page = 1
      let type = 1
      let page = 1

      let res = await comonDataApi.deleteCommonType(Number(id), type)

      if (res.data.success === true) {
        type = 2
        do {
          res = await comonDataApi.deleteCommonType(Number(id), type, page)

          page += 1 // Increment the page number
        } while (res.data.isPaging === true)

        // Step 3: Send the final request with type = 3
        type = 3
        res = await comonDataApi.deleteCommonType(Number(id), type)

        if (res.data.success === true) {
          toast.success('Reset data successful')
          setIsDeleted(true)
          isLoadingReset(false)
        } else {
          toast.error(res.data.message)
          setIsDeleted(false)
        }
      } else {
        isLoadingReset(false)
        toast.error(res.data.message)
      }
    } catch (error) {
      isLoadingReset(false)
      toast.error('Delete failed. Please check your connection.')
    } finally {
      isLoadingReset(false)
      setIsSetup(false)
    }
  }

  function handleUploadError(error: any) {}

  const onChangeFile = async (file: File[]) => {
    setProgress(0)
    if (!file?.length) return
    const data = new FormData()
    data.append('file', file[0])
    setStep(STEP.UPLOADING)
    let errorOccurred = false // Biến cờ để kiểm tra lỗi
    setStepName(STEP_LOADING.Output)
    try {
      let currentPage = 1
      let currentPageOutPut = 1
      let shouldContinue = true
      let shouldContinueOutPut = true

      await comonDataApi
        .uploadInitFile(Number(interfaceId), data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.Output)
          if (data.success) {
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
            errorOccurred = true // Đặt biến cờ nếu có lỗi
          }
        })
        .catch((data) => {
          NotifyService.error(data.response.data.Message)
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true // Đặt biến cờ nếu có lỗi
        })

      if (errorOccurred) {
        return
      }

      while (shouldContinueOutPut) {
        const { data: dataOutput } = await comonDataApi.uploadCommonStationFile(
          Number(interfaceId),
          10,
          data,
          currentPageOutPut,
          isDeleted,
        )

        if (dataOutput.isPaging === true) {
          currentPageOutPut++
        } else {
          shouldContinueOutPut = false
          setProgress(100)
          setStepName(STEP_LOADING.Input)
        }

        if (dataOutput.success) {
          // Xử lý thành công
        } else {
          // Xử lý lỗi
          setStep(STEP.UPLOAD_ERROR)
          setProgress(0)
          NotifyService.error('Upload file error')
          if (dataOutput.result) {
            saveAs(
              fileContentToBlob(
                dataOutput.result.fileContents,
                dataOutput.result.contentType,
              ),
              dataOutput.result.fileDownloadName,
            )
          }
          errorOccurred = true
        }
      }

      await comonDataApi
        .uploadCommonStationFile(Number(interfaceId), 11, data, 1, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.Hydraulic)
          if (data.success) {
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
            errorOccurred = true // Đặt biến cờ nếu có lỗi
          }
        })
        .catch((data) => {
          NotifyService.error(data.response.data.Message)
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true // Đặt biến cờ nếu có lỗi
        })

      if (errorOccurred) {
        return
      }

      await comonDataApi
        .uploadHydraulicFile(Number(interfaceId), 1, data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.Fertigation)
          if (data.success) {
            setHydraulic(data.data)
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
            errorOccurred = true // Đặt biến cờ nếu có lỗi
          }
        })
        .catch((data) => {
          NotifyService.error(data.response.data.Message)
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true // Đặt biến cờ nếu có lỗi
        })

      if (errorOccurred) {
        return
      }

      await comonDataApi
        .uploadCommonFertigationFile(Number(interfaceId), 9, data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.Plant)
          if (data.success) {
            setFertigation(data.data)
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
          }
        })
        .catch(() => {
          NotifyService.error('Upload file error')
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true
        })
      if (errorOccurred) {
        return
      }

      await comonDataApi
        .uploadCommonFile(Number(interfaceId), 2, data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.Soils)
          if (data.success) {
            setEtData(data.data.etReference)
            setPlantData(data.data.plant)
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
          }
        })
        .catch(() => {
          NotifyService.error('Upload file error')
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true
        })
      if (errorOccurred) {
        return
      }

      await comonDataApi
        .uploadCommonSoilFile(Number(interfaceId), 3, data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.Emitter)
          if (data.success) {
            setSoils(data.data)
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
          }
        })
        .catch(() => {
          NotifyService.error('Upload file error')
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true
        })

      if (errorOccurred) {
        return
      }

      await comonDataApi
        .uploadCommonEmitterFile(Number(interfaceId), 4, data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.AreaZone)
          if (data.success) {
            setEmitter(data.data)
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
          }
        })
        .catch(() => {
          NotifyService.error('Upload file error')
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true
        })

      if (errorOccurred) {
        return
      }

      await comonDataApi
        .uploadCommonAreaFile(Number(interfaceId), 5, data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.Sensor)
          if (data.success) {
            setAreaZone(data.data)
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
          }
        })
        .catch(() => {
          NotifyService.error('Upload file error')
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true
        })

      if (errorOccurred) {
        return
      }

      await comonDataApi
        .uploadCommonSensorFile(Number(interfaceId), 6, data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.EtZone)
          if (data.success) {
            setSensor(data.data)
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
          }
        })
        .catch(() => {
          NotifyService.error('Upload file error')
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true
        })

      if (errorOccurred) {
        return
      }

      await comonDataApi
        .uploadCommonEtZoneFile(Number(interfaceId), 7, data, isDeleted)
        .then(({ data }) => {
          setStepName(STEP_LOADING.Station)
          if (data.success) {
            setEtZone(data.data)
            setProgress(100)
          } else {
            setStep(STEP.UPLOAD_ERROR)
            setProgress(0)
            NotifyService.error('Upload file error')
            if (data.result) {
              saveAs(
                fileContentToBlob(
                  data.result.fileContents,
                  data.result.contentType,
                ),
                data.result.fileDownloadName,
              )
            }
          }
        })
        .catch(() => {
          NotifyService.error('Upload file error')
          setStep(STEP.UPLOAD_ERROR)
          errorOccurred = true
        })

      if (errorOccurred) {
        return
      }

      while (shouldContinue) {
        const { data: dataStation } =
          await comonDataApi.uploadCommonStationFile(
            Number(interfaceId),
            8,
            data,
            currentPage,
            isDeleted,
          )

        if (dataStation.isPaging === true) {
          currentPage++
          setStepName(STEP_LOADING.Station)
        } else {
          shouldContinue = false
          setProgress(100)
          setStep(STEP.REVIEW)
        }

        setStepName(STEP_LOADING.Station)
        setResultStation(dataStation)
        if (dataStation.success) {
          // Xử lý thành công
        } else {
          // Xử lý lỗi
          setStep(STEP.UPLOAD_ERROR)
          setProgress(0)
          NotifyService.error('Upload file error')
          if (dataStation.result) {
            saveAs(
              fileContentToBlob(
                dataStation.result.fileContents,
                dataStation.result.contentType,
              ),
              dataStation.result.fileDownloadName,
            )
          }
          errorOccurred = true
        }
      }
    } catch (error) {
      console.error(error)
      setProgress(0)
      setIsDeleted(false)
      setStep(STEP.UPLOAD_ERROR)
      if (axios.isAxiosError(error) && error.response?.status === 400) {
        NotifyService.error(
          'Hardware configuration identified. Please contact Cisgenics Admin for further troubleshoot.',
        )
        return
      }
      NotifyService.error('An unexpected error occurred')
    }
  }

  const { data: errorOverlay } = useCheckOverlay(interfaceId)

  const handleNext = () => {
    if (!!errorOverlay) {
      setStep(STEP.PIN_STATION)
    } else {
      navigate(OPERATIONS_ROUTES.index.to)
    }
  }

  const getStepNumber = (stepName: StepLoadingType): number | string => {
    if (stepName === 'Plant & ET Reference') {
      // Trả về số bước với một dấu hiệu đặc biệt hoặc chỉ là số bước tùy ý bạn
      return '5'
    }
    const stepMap: { [key in StepLoadingType]: number } = {
      Output: 1,
      Input: 2,
      Hydraulic: 3,
      Fertigation: 4,
      Plant: 5,
      Soils: 6,
      Emitter: 7,
      AreaZone: 8,
      Sensor: 9,
      EtZone: 10,
      Station: 11,
    }

    return stepMap[stepName] || 'Unknown'
  }

  const render = () => {
    switch (step) {
      case STEP.CHOOSE_FILE:
        return (
          <Box className={classes.root}>
            <Typography className={classes.pageTitle}>Common Data</Typography>
            <Stack mt="80px" alignItems="flex-start">
              <Stack direction="row" spacing={1}>
                <Typography className={classes.stepTitle}>
                  Step 1. Reset common data
                </Typography>
              </Stack>

              <Box className={`${classes.actions} ${classes.actionsDow}`}>
                <LoadingButton
                  variant="secondary"
                  className={classes.btnDownload}
                  onClick={() => {
                    if (!selectedInterface?.status) {
                      setIsSetup(true)
                    } else {
                      handleDelete()
                    }
                  }}
                  startIcon={<CopyOneIcon />}
                  loading={loadingReset}
                >
                  Reset data
                </LoadingButton>
              </Box>
              <Typography className={classes.stepTitle}>
                Step 2. Fill in your data in the Excel template
              </Typography>
              <Box className={`${classes.actions} ${classes.actionsDow}`}>
                {isDownloading ? (
                  <LoadingButton
                    className={classes.btnDownload}
                    startIcon={<CopyOneIcon />}
                    loading
                    variant="secondary"
                  >
                    Download Excel Template
                  </LoadingButton>
                ) : (
                  <Button
                    variant="secondary"
                    className={classes.btnDownload}
                    onClick={onDownload}
                    startIcon={<CopyOneIcon />}
                  >
                    Download Excel Template
                  </Button>
                )}
              </Box>
              <Typography className={classes.stepTitle}>
                Step 3. Upload the XLSX
              </Typography>
              <Button
                sx={{
                  ...(!isDeleted && {
                    opacity: 0.5,
                    pointerEvents: 'none',
                    userSelect: 'none',
                  }),
                }}
                variant="secondary"
              >
                <InputFile
                  accept={XLSX_ACEPT}
                  formats={XLSX_FORMAT}
                  onChange={onChangeFile}
                />
              </Button>
            </Stack>
          </Box>
        )
      case STEP.UPLOADING:
        return (
          <Box className={classes.root}>
            <Typography className={classes.pageTitle}>Common Data</Typography>
            <Stack p="150px 0px 20px 0px" width="210px">
              {stepName && (
                <Stack>
                  <Typography className={classes.txtImportData}>
                    Importing Data ({getStepNumber(stepName)} / 11)
                  </Typography>
                  <Typography className={classes.txtImport}>
                    Importing {stepName} Data...
                  </Typography>
                  <Box mt="20px">
                    <LinearProgressWithLabel value={progress} />
                  </Box>
                </Stack>
              )}
            </Stack>
            {/* <CircularStatic progress={progress} /> */}
            <Typography className={classes.title}>Processing Data</Typography>
            <Typography className={classes.description}>
              Please do not close the window
            </Typography>
          </Box>
        )
      case STEP.UPLOAD_ERROR:
        return (
          <Box className={classes.root}>
            <Typography className={classes.pageTitle}>Common Data</Typography>
            <DatabaseAlerIcon className={classes.errorIcon} />
            <Typography className={classes.title}>
              Unable to import data
            </Typography>
            <Typography className={classes.description}>
              The file is not in the right format, or has typo errors
            </Typography>
            <Box className={classes.actions}>
              <Button className={classes.btnTry} onClick={onTryAgain}>
                Try Again
              </Button>
            </Box>
          </Box>
        )
      case STEP.REVIEW:
        return (
          <>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              className={classes.Table}
            >
              <Typography className={classes.TableTitle}>
                Review Common Data
              </Typography>
              <Stack alignItems="center">
                <Button
                  variant="contained"
                  className={classes.btnTry}
                  onClick={() => handleNext()}
                >
                  Next
                </Button>
              </Stack>
            </Stack>
            <CommonDataTable
              dataSensor={sensor}
              dataHydraulic={hydraulic?.pipe}
              dataFertigation={fertigation}
              dataEt={etData}
              dataPlant={plantData}
              dataEmitter={emitter}
              dataAreas={areaZone?.data}
              dataSoil={soils}
              dataEtZone={etZone}
              totalCountAreas={areaZone?.totalCount}
            />
          </>
        )

      case STEP.PIN_STATION:
        return (
          <PinStationsOnMap
            interfaceId={Number(interfaceId)}
            data={station}
            onClose={onClose}
          />
        )
    }
  }

  return (
    <SetUpLayout
      title="Common Data"
      rightLayout={
        step === STEP.PIN_STATION || !errorOverlay ? null : (
          <Stack className={classes.mapViewRight}>
            <MapViewRightMenu />
          </Stack>
        )
      }
      header={
        step === STEP.PIN_STATION ? null : (
          <SetUpHeaderModal
            title="Common Data"
            onCancel={step === STEP.UPLOADING ? onErrors : onBack}
            showBtnClose={!(step === STEP.REVIEW)}
          />
        )
      }
      fullWidth={step === STEP.PIN_STATION ? true : false}
    >
      {render()}

      <Dialog
        open={isSetup}
        onClose={() => {
          setIsSetup(false)
        }}
      >
        <Box
          sx={{
            backgroundColor: 'background.default',
          }}
        >
          <Stack sx={{ padding: '14px 30px' }}>
            <Typography
              sx={{
                color: 'text.main',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '24px',
                minHeight: '24px',
                minWidth: '192px',
              }}
            >
              Warning
            </Typography>
          </Stack>

          <Stack
            sx={{
              backgroundColor: 'common.white',
              minWidth: '378px',
              padding: '30px',
              boxShadow: '0px 0px 30px rgba(132, 132, 132, 0.25)',
            }}
          >
            <Stack>
              <Typography
                sx={{
                  color: '#000000',
                  marginBottom: '10px',
                }}
                variant="h3"
              >
                You're resetting all data for the controller{' '}
                <b>
                  {selectedInterface?.interfaceCustomName} (
                  {selectedInterface?.interface_name})
                </b>
              </Typography>

              <Typography
                sx={{
                  fontSize: '14px',
                  color: '#FF0000',
                  marginBottom: '20px',
                }}
                variant="h3"
              >
                This action is not reversible, would you like to proceed?
              </Typography>
            </Stack>

            <Box
              sx={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}
            >
              <Button
                variant="secondary"
                className={classes.btnTry}
                onClick={() => navigate(OPERATIONS_ROUTES.index.to)}
              >
                Back
              </Button>

              {loadingReset ? (
                <LoadingButton
                  className={classes.btnTry}
                  startIcon={<CopyOneIcon />}
                  loading
                  variant="contained"
                >
                  Confirm
                </LoadingButton>
              ) : (
                <Button
                  variant="contained"
                  className={classes.btnTry}
                  onClick={() => handleDelete()}
                >
                  Confirm
                </Button>
              )}
            </Box>
          </Stack>
        </Box>
      </Dialog>
    </SetUpLayout>
  )
})

export default SetUpSecond
